export default "__VITE_ASSET__XCgcwegA__"